import vi_VN from '../../date-picker/locale/vi_VN'
export default vi_VN



// WEBPACK FOOTER //
// ./components/calendar/locale/vi_VN.js